import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from '../../gotland/src/app/app.module';

try {
    const cachedLocale = localStorage.getItem('LOCALIZE_DEFAULT_LANGUAGE');
    if (cachedLocale === null) {
        localStorage.setItem('LOCALIZE_DEFAULT_LANGUAGE', 'et');
    }
} catch (err) {
    localStorage.setItem('LOCALIZE_DEFAULT_LANGUAGE', 'et');
}

fetch('/assets/settings/settings.json').then(async (res) => {
    const configuration = await res.json();
    if (configuration.production) {
        enableProdMode();
    }
    platformBrowserDynamic([{ provide: 'ENV', useValue: configuration }])
        .bootstrapModule(AppModule)
        .catch((err) => console.error(err));
});
